import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import Config from 'conf';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import axios from 'axios';
import { parse } from 'url';
import { withStyles, Button } from '@material-ui/core';
import { Logger } from 'data/common';
import WaitingLayout from './component/WaitingLayout';
import { apiAuthProvider } from './actions';

const electron = require('electron');

const BrowserWindow = electron.remote.BrowserWindow;

class Login extends Component {
    static propTypes = {
        apiAuthProvider: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired
    };

    state = {
        loading: true,
        status_message: null
    };

    componentDidMount() {
        this.startSignIn();
    }

    signInWithPopup() {
        return new Promise((resolve, reject) => {
            //const authWindow = new remote.BrowserWindow({
            const authWindow = new BrowserWindow({
                width: 500,
                height: 600,
                show: true
            });

            // TODO: Generate and validate PKCE code_challenge value
            const urlParams = {
                response_type: 'code',
                redirect_uri: Config.googleApi.redirectUrl,
                client_id: Config.googleApi.clientId,
                scope: Config.googleApi.scope
            };

            const authUrl = `${Config.googleApi.GOOGLE_AUTHORIZATION_URL}?${qs.stringify(urlParams)}`;

            function handleNavigation(url) {
                const query = parse(url, true).query;
                if (query) {
                    if (query.error) {
                        reject(new Error(`There was an error: ${query.error}`));
                    } else if (query.code) {
                        // Login is complete
                        authWindow.removeAllListeners('closed');
                        setImmediate(() => authWindow.close());

                        // This is the authorization code we need to request tokens
                        resolve(query.code);
                    }
                }
            }

            authWindow.on('closed', () => {
                this.setState({
                    status_message: Translator.translate('login.popClosed'),
                    loading: false
                });
            });

            authWindow.webContents.on('will-navigate', (event, url) => {
                handleNavigation(url);
            });

            authWindow.loadURL(authUrl);
        });
    }

    exchangeOAuth2Token(params) {
        const { apiAuthProvider } = this.props;
        apiAuthProvider(params.id_token, 'google', 'electron')
            .then(() => {
                document.location.reload();
            })
            .catch(e => {
                Logger.error(e);
                let status_message = Translator.translate('login.defaultError');
                if (e && e.data && (e.data.message === 'ERR_LOGIN' || e.data.message === 'Invalid credentials provided'))
                    status_message = Translator.translate('login.errorWrongAccount');
                else if (e && e.data && e.data.message === 'Failed to fetch') status_message = Translator.translate('login.errorConnexionServer');

                this.setState({
                    status_message: status_message,
                    loading: false
                });
            });
    }

    fetchAccessTokens(code) {
        return axios.post(
            Config.googleApi.GOOGLE_TOKEN_URL,
            qs.stringify({
                code,
                client_id: Config.googleApi.clientId,
                redirect_uri: Config.googleApi.redirectUrl,
                grant_type: Config.googleApi.grantType
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    }

    startSignIn() {
        this.setState({
            status_message: Translator.translate('login.popUpMess'),
            loading: true
        });
        this.signInWithPopup().then(async result => {
            this.setState({
                status_message: Translator.translate('login.waitingServer')
            });
            let code = await this.fetchAccessTokens(result);

            this.exchangeOAuth2Token({
                id_token: code.data.id_token,
                audience: Config.googleApi.clientId
            });
        });
    }

    render() {
        const { classes } = this.props;
        const { loading, status_message } = this.state;
        return (
            <WaitingLayout>
                <div style={{ marginBottom: 50 }}>
                    {!loading ? (
                        <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={this.startSignIn.bind(this)}>
                            {Translator.translate('login.restartConnexion')}
                        </Button>
                    ) : null}
                    <div className={classes.errorLoginMessage}>{status_message}</div>
                </div>
            </WaitingLayout>
        );
    }
}

function mapStateToProps() {
    return {};
}

const styles = theme => ({
    errorLoginMessage: {
        padding: 5,
        maxWidth: '100%',
        width: 400,
        textAlign: 'center',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius
    }
});

module.exports = withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ apiAuthProvider }, dispatch)
    )(withStyles(styles, { withTheme: true })(Login))
);



// WEBPACK FOOTER //
// ./scenes/Login/electron.js